import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const authorDetailsContainer = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s16,
});

export const authorStreamCardDetails = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: `${space.s16}px 0`,
});

export const authorStreamDescription = style({
  ...typography.bodyMd,
  color: themeVars.container.foreground.secondary,
  marginTop: space.s4,
});

export const authorStreamCard = style({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: borderRadius.r12,
  backgroundColor: themeVars.container.primary.background.idle,
  padding: space.s12,
  border: `1px solid ${themeVars.container.border.default}`,
  height: '100%',
});

export const homeStreamCardMiniFooter = style({
  marginTop: 'auto',
});

export const authorStreamsContainer = style({
  marginTop: space.s8,
});

export const authorSectionHeader = style({
  marginBottom: 0,
});

export const winnerUserContainer = style({
  display: 'flex',
  gap: space.s12,
  minWidth: 120,
  alignItems: 'center',
});
